<template>
  <footer class="footer" :class="{ activation: isActivation } ">
    <section class="section footer-top">
      <div class="contacts">
        <div class="contacts-title">cлужба поддержки 24/7</div>
        <div class="contacts-content">
          <a href="tel:+375298888719" class="contacts-link tel">+375 29 888 87 19</a>
          <a href="https://t.me/GoldappleSupportBot" class="contacts-link email tg-link" target="_blank">
            <img
              class="social-logo"
              src="/static/img/icons/tg.svg"
              alt=""
            />
            Telegram
          </a>
          <a href="https://api.whatsapp.com/send?phone=78007707021" class="contacts-link email wa-link" target="_blank">
            <img
              class="social-logo"
              style="height: 20px; margin-right: 0px;"
              src="/static/img/icons/wa.svg"
            />
            WhatsApp
          </a>
        </div>
      </div>
      <a href="http://goldapple.by" class="logo-wrap" target="_blank">
        <span class="visually-hidden"></span>
        <img src="/static/img/icons/logo.svg" alt="Gold Apple" class="logo-img">
      </a>
      <div v-if="isActivation" class="payments">
        <a href="/static/docs/Gift Cards_Правила пользования подарочными картами.pdf" target="_blank" class="how-use">как воспользоваться картой</a>
      </div>
      <div class="payments" v-else>
        <div class="payments-docs">
          <a href="/static/docs/Правила продажи и оборота подарочных карт.pdf" target="_blank" class="payments-docs-link">условия покупки и оферта</a>
          <a href="/static/docs/Золотое Яблоко Подарочные карты Условия доставки.pdf" target="_blank" class="payments-docs-link">условия доставки</a>
        </div>
      </div>
    </section>
    <section class="logo-mobile">
      <div>
        <a href="http://goldapple.by" target="_blank" style="margin: 0 auto;">
          <img src="/static/img/icons/logo.svg" alt="Gold Apple" class="logo-img">
        </a>
      </div>
    </section>
    <section class="contacts-mobile">
      <div class="contacts-content">
        <a href="tel:+375298888719" class="contacts-link tel">+375 29 888 87 19</a>
        <a href="https://t.me/GoldappleSupportBot" class="contacts-link email tg-link" target="_blank">
          <img
            class="social-logo"
            src="/static/img/icons/tg.svg"
            alt=""
          />
          Telegram
        </a>
        <a href="https://api.whatsapp.com/send?phone=78007707021" class="contacts-link email wa-link" target="_blank">
          <img
            class="social-logo"
            style="height: 20px; margin-right: 0px;"
            src="/static/img/icons/wa.svg"
          />
          WhatsApp
        </a>
      </div>
    </section>
    <section class="section footer-middle">
      <div class="footer-logos">
        <div class="footer-logo logo-visa"></div>
        <div class="footer-logo logo-mastercard"></div>
        <div class="footer-logo logo-apay"></div>
        <div class="footer-logo logo-spay"></div>
        <div class="footer-logo logo-mcard-idcheck"></div>
        <div class="footer-logo logo-visa-secure"></div>
        <div class="footer-logo logo-abank"></div>
        <div class="footer-logo logo-belcard"></div>
        <div class="footer-logo logo-belcard-password"></div>
      </div>
    </section>
    <section class="section footer-bottom">
      <p class="copyright-text">ООО «Яблоко Бьюти Маркет»  ·  УПН 193323100  ·  Юридический адрес: Республика Беларусь, 220013, г. Минск, ул. 2-я Шестая линия, д. 11, пом. 10Б  ·  Регистрационный номер в Торговом реестре Республики Беларусь: 508044 от 21.04.2021  ·  График работы интернет-магазина: круглосуточно</p>
    </section>
  </footer>
</template>

<script>
export default {
  name: 'footerView',
  data () {
    return {}
  },
  computed: {
    isActivation () {
      return this.$route.name === 'Activation'
    }
  }
}
</script>

<style src="@/components/Footer.css" scoped/>
